import Button from "@material-ui/core/Button"
import IconButton from "@material-ui/core/IconButton"
import withStyles from "@material-ui/styles/withStyles"
import React from "react"

const muiButtonColors = ["default", "inherit", "primary", "secondary"]

const ButtonRoot = React.forwardRef(
  ({ buttonColor: _buttonColor, ...props }, ref) => (
    <Button ref={ref} {...props} />
  )
)

/**
 *
 */
const StyledButtonBase = withStyles(({ palette, spacing }) => ({
  root: ({ variant, color, buttonColor }) => {
    const isContained = variant === "contained"
    const paletteColor = buttonColor || color
    let mainColor = palette.primary.main
    let contrastColor = palette.primary.contrastText
    if (paletteColor in palette) {
      mainColor = palette[paletteColor].main
      contrastColor = palette[paletteColor].contrastText
    }
    return {
      border: `1px solid ${isContained ? contrastColor : mainColor}`, // Borde azul
      color: isContained ? contrastColor : mainColor, // Texto azul
      backgroundColor: isContained ? mainColor : "transparent", // Fondo transparente
      transition: "all 0.2s ease-in-out", // Suaviza el hover
      // gap: "8px", // Espacio entre el icono y el texto
      padding: spacing(0.5, 2), // 🔹 Espaciado interno similar al botón original
      borderRadius: "10px",
      boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.15)",
      "& svg": {
        color: isContained ? contrastColor : mainColor, // Cambia el color del icono a blanco
      },
      "&:hover": {
        border: `1px solid ${isContained ? mainColor : contrastColor}`,
        backgroundColor: isContained ? contrastColor : mainColor, // Fondo azul en hover
        color: isContained ? mainColor : contrastColor, // Texto blanco en hover
        transform: "scale(1.07)", // Cambio mínimo de tamaño
        boxShadow: "3px 3px 8px rgba(0, 0, 0, 0.25)",
        "& svg": {
          color: isContained ? mainColor : contrastColor, // Cambia el color del icono a blanco
        },
        "&.email-button img": {
          filter: "invert(100%) brightness(1000%)", // Hace la imagen blanca en hover solo en este botón
        },
      },
    }
  },
}))(ButtonRoot)

export const StyledButton = React.forwardRef(
  ({ color = "primary", ...props }, ref) => (
    <StyledButtonBase
      ref={ref}
      {...props}
      buttonColor={color}
      color={muiButtonColors.includes(color) ? color : "primary"}
    />
  )
)

export const TgIcon = withStyles(theme => ({
  root: {
    border: `1px solid ${theme.palette.primary.main}`, // Borde azul
    color: theme.palette.primary.contrastText, // Texto azul
    backgroundColor: "transparent", // Fondo transparente
    transition: "all 0.2s ease-in-out", // Suaviza el hover
    padding: theme.spacing(1), // 🔹 Espaciado interno similar al botón original
    boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.15)",
    "& svg": {
      color: theme.palette.primary.main, // Cambia el color del icono a blanco
    },
    "&:hover": {
      backgroundColor: theme.palette.primary.main, // Fondo azul en hover
      color: theme.palette.primary.contrastText, // Texto blanco en hover
      transform: "scale(1.07)", // Cambio mínimo de tamaño
      boxShadow: "3px 3px 8px rgba(0, 0, 0, 0.25)",
      "& svg": {
        color: theme.palette.primary.contrastText, // Cambia el color del icono a blanco
      },
    },
  },
}))(IconButton)
